import { render, staticRenderFns } from "./DefectOverlayPopupContent.vue?vue&type=template&id=46fc7dfa&scoped=true"
import script from "./DefectOverlayPopupContent.vue?vue&type=script&lang=js"
export * from "./DefectOverlayPopupContent.vue?vue&type=script&lang=js"
import style0 from "./DefectOverlayPopupContent.vue?vue&type=style&index=0&id=46fc7dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_tjpztcs3aockkrmwoqc6dtxv4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fc7dfa",
  null
  
)

export default component.exports